import { EMAIL_KIND_PROJECT_REVIEWED, type Project } from '@/api/client';
import { ProjectEmailModal } from './ProjectEmailModal';

export type ProjectReviewedEmailModalMode = 'status_transition' | 'email_only';

export interface ProjectReviewedEmailModalProps {
  open: boolean;
  onClose: () => void;
  project: Project;
  mode: ProjectReviewedEmailModalMode;
  intendedState?: string;
}

export function ProjectReviewedEmailModal({
  open,
  onClose,
  project,
  mode,
  intendedState,
}: ProjectReviewedEmailModalProps) {
  return (
    <ProjectEmailModal
      open={open}
      onClose={onClose}
      project={project}
      emailKind={EMAIL_KIND_PROJECT_REVIEWED}
      modalTitle={`Проверка завершена: ${project.name ?? 'Проект'}`}
      requireNewState={mode === 'status_transition'}
      newStateWhenSaving={mode === 'status_transition' ? intendedState : undefined}
    />
  );
}
